import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface DraftPlanIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function DraftPlanIcon({ color = RoutalPalette.secondary20, style = {}, ...props }: DraftPlanIconProps) {
  const fillColor = style.color || color;
  return (
    <SvgIcon {...props} viewBox="0 0 12 12" style={{ height: `14px`, width: `14px`, ...style }}>
      <g clipPath="url(#clip0_1859_9113)">
        <path
          d="M9.66456 5C9.81906 5 9.96506 4.9285 10.0596 4.8065C10.1541 4.6845 10.1871 4.5255 10.1491 4.376C9.99356 3.7675 9.67656 3.2115 9.23256 2.7675L7.49006 1.025C6.82906 0.364 5.95006 0 5.01506 0H2.75756C1.37956 0 0.258057 1.1215 0.258057 2.5V9.5C0.258057 10.8785 1.37956 12 2.75806 12H4.25806C4.53406 12 4.75806 11.776 4.75806 11.5C4.75806 11.224 4.53406 11 4.25806 11H2.75806C1.93106 11 1.25806 10.327 1.25806 9.5V2.5C1.25806 1.673 1.93106 1 2.75806 1H5.01556C5.09706 1 5.17806 1.004 5.25806 1.0115V3.5C5.25806 4.327 5.93106 5 6.75806 5H9.66456ZM6.25806 3.5V1.3295C6.44756 1.4385 6.62406 1.5735 6.78306 1.7325L8.52556 3.475C8.68256 3.632 8.81706 3.809 8.92706 4H6.75806C6.48256 4 6.25806 3.7755 6.25806 3.5ZM11.8191 5.9395C11.2521 5.3725 10.2641 5.3725 9.69756 5.9395L6.34406 9.293C5.96656 9.6705 5.75806 10.173 5.75806 10.7075V11.5005C5.75806 11.7765 5.98206 12.0005 6.25806 12.0005H7.05106C7.58556 12.0005 8.08756 11.792 8.46506 11.4145L11.8186 8.061C12.1021 7.7775 12.2581 7.401 12.2581 7C12.2581 6.599 12.1021 6.2225 11.8191 5.9395ZM11.1116 7.3535L7.75756 10.707C7.56906 10.896 7.31806 11 7.05056 11H6.75756V10.707C6.75756 10.44 6.86156 10.189 7.05056 10L10.4046 6.6465C10.5931 6.4575 10.9226 6.4575 11.1116 6.6465C11.2061 6.7405 11.2581 6.866 11.2581 7C11.2581 7.134 11.2061 7.259 11.1116 7.3535Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1859_9113">
          <rect width="12" height="12" fill={fillColor} />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
